import React from "react";
import { Alert, Card, Col, Image, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ApiHelper from "../../../../../Helpers/ApiHelper";
import { folderEnum } from "../../../../../Helpers/EnumHelper";
import { confirmDelete } from "../../../SharedComponents/ListView";

export default function TestItemList({ testItems, DeleteTestItem }) {
  const { t } = useTranslation();

  const handleDelete = (sq) =>
    confirmDelete({
      title: t("areYouSure"),
      message: t("deleteConfirmMessage"),
      confirmText: t("yes"),
      cancelText: t("giveUp"),
      onConfirm: () => DeleteTestItem(sq),
    });

  const HandleQuestionImageFile = (fileName) => {
    if (fileName.endsWith(".mp3"))
      return (
        <audio controls name="media">
          <source src={ApiHelper.cloudFrontURL + folderEnum.question + fileName} type="audio/mpeg" />
        </audio>
      );
    else if (fileName.endsWith(".webm"))
      return (
        <video controls name="media" width="130" height="130">
          <source src={ApiHelper.cloudFrontURL + folderEnum.question + fileName} type="video/webm" />
        </video>
      );
    else if (fileName.endsWith(".mp4"))
      return (
        <video controls name="media" width="130" height="130">
          <source src={ApiHelper.cloudFrontURL + folderEnum.question + fileName} type="video/mp4" />
        </video>
      );
    return <Image src={ApiHelper.cloudFrontURL + folderEnum.question + fileName} width="130" height="130" />;
  };
  return (
    <>
      {testItems?.length > 0 &&
        testItems.map((sq, i) => {
          return (
            <Card key={i} className="mb-3">
              <Card.Body>
                <span
                  style={{
                    position: "absolute",
                    top: "2px",
                    left: "12px",
                    fontSize: "12px",
                    fontWeight: "bold",
                  }}
                >
                  K = {sq.testItem.factor}
                </span>
                <span
                  style={{
                    position: "absolute",
                    top: "2px",
                    left: "70px",
                    fontSize: "12px",
                    fontWeight: "bold",
                  }}
                >
                  Sıra = {sq.order}
                </span>
                <Row style={{ paddingTop: "5px" }}>
                  <Col>
                    {sq.testItem.imagePath && HandleQuestionImageFile(sq.testItem.imagePath)}
                    {sq.testItem.questionText && sq.testItem.questionText}
                  </Col>
                  {sq.testItem.answers.options
                    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0)) // Sort answers by order
                    .map((opt, i) => {
                      return (
                        <Col
                          key={"i" + i}
                          style={
                            opt.isCorrect
                              ? {
                                  border: "2px solid green",
                                  borderRadius: "5px",
                                  padding: "5px",
                                  background: "aquamarine",
                                  margin: "10px",
                                }
                              : {
                                  background: "gainsboro",
                                  padding: "5px",
                                  margin: "10px",
                                  borderRadius: "5px",
                                }
                          }
                        >
                          <Row className={"justify-content-center"}>
                            <Col xs={"auto"}>{opt.text && opt.text} </Col>
                            <Col xs={"auto"}>
                              {opt.path && (
                                <Image
                                  src={ApiHelper.cloudFrontURL + folderEnum.question + opt.path}
                                  width="100"
                                  height="100"
                                />
                              )}
                            </Col>
                          </Row>
                        </Col>
                      );
                    })}
                </Row>
                <Alert.Link
                  style={{
                    position: "absolute",
                    top: "0px",
                    right: "10px",
                    color: "red",
                    cursor: "pointer",
                  }}
                  variant="danger"
                  onClick={() => handleDelete(sq)}
                >
                  {t("delete")}
                </Alert.Link>
              </Card.Body>
            </Card>
          );
        })}
    </>
  );
}
